import { calculateLeadScore } from "../../visitor-checks/calculateLeadScore";
import { stepsNames } from "../config.const";
import type { SubPractices } from "../config.types";

export const familyAlimony: SubPractices = {
  firstScreen: "service-type",
  screens: {
    "service-type": {
      next: async () => "zip-code",
    },
    "zip-code": {
      next: async ({ answers }) => {
        const { skip, state } = answers;

        if (skip) {
          return "state-selection";
        }

        if (state === "unsupported") {
          return "unsupported";
        }

        return "location-confirmation";
      },
    },
    "state-selection": {
      next: async ({ answers }) => {
        const { state } = answers;

        if (state === "unsupported") {
          return "unsupported";
        }

        return "location-confirmation";
      },
    },
    unsupported: {
      next: async () => "unsupported-confirmed",
      sanitize: true,
    },
    "unsupported-confirmed": {
      next: async () => "unsupported-confirmed",
    },
    "location-confirmation": {
      next: async () => "case-urgency",
    },
    "case-urgency": {
      next: async () => "more-info",
    },
    "more-info": {
      next: async ({ answers }) => {
        calculateLeadScore(answers, stepsNames["more-info"]);
        return "create-meeting";
      },
    },
    "create-meeting": {
      next: async () => "contact-info",
    },
    "contact-info": {
      next: async () => {
        return "intake-confirmation";
      },
      isAuth: true,
      sanitize: true,
    },
    "intake-confirmation": {
      next: async () => undefined,
    },
    "out-of-scope": {
      next: async () => undefined,
    },
  },
};
